import { Box, Button, LinearProgress } from '@mui/material';
import React from 'react';
// import { StyledProgress } from './vido-player.styled';
import { ReactComponent as Pause } from '../../../assets/icons/Pause.svg';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { calculationProgressVideo, convertToMinutesAndSeconds } from '@/utils';

interface Props {
  play: boolean;
  playedSeconds: number;
  onClick: () => void;
  widthProgress?: string;
  videoDuration: number;
}

function VideoProgressPlayer({
  play,
  playedSeconds,
  onClick,
  widthProgress,
  videoDuration,
}: Props) {
  const duration = convertToMinutesAndSeconds(Math.round(videoDuration));
  const progress = calculationProgressVideo(playedSeconds, videoDuration);

  return (
    <>
      <Box
        sx={{
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          height: '40px',
          borderRadius: '88px',
          position: 'relative',
          cursor: 'cursor',
        }}
      >
        <Button
          sx={{ position: 'absolute', left: '0', top: '10%', zIndex: 10 }}
          onClick={onClick}
        >
          {play ? <Pause /> : <PlayArrowIcon style={{ color: 'white' }} />}
        </Button>
        <LinearProgress
          sx={{
            width: widthProgress ?? '50vw',
            borderRadius: '88px',
            height: '40px',
            backgroundColor: 'LinearProgress',
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#662B5C',
            },
          }}
          variant="determinate"
          value={progress}
        />

        <h5 color="white" style={{ color: 'white', position: 'absolute' }}>
          {convertToMinutesAndSeconds(playedSeconds).replace('0', '')}/
          {duration}
        </h5>
      </Box>
    </>
  );
}

export default VideoProgressPlayer;
